<template>
  <div>
    <div class="bind-customer-account" v-if="!loading">
      <div class="header">
        <img
          src="../../../../assets/imgs/work-wx/customer/bind-customer-account/back-icon.png"
          @click="goBack"
          v-if="!isJump"
        />
        绑定客户账号
      </div>
      <div class="content">
        <div class="search-input">
          <div class="input">
            <img
              src="../../../../assets/imgs/work-wx/common/icon-search.svg"
              class="pre-icon"
            />
            <input
              type="text"
              placeholder="请输入用户ID"
              class="search-input"
              v-model.trim="search.user_account_id"
              @keydown.enter="onSearch"
            />
          </div>
          <div class="search-btn" @click="onSearch">搜索</div>
        </div>

        <account-info :user-info="userInfo"></account-info>
      </div>
    </div>

    <div class="loading" v-else>
      <van-loading color="#1989fa" />
    </div>
  </div>
</template>

<script>
import utils from '@/services/tools';
import toast from '@/services/toast.js';
import AccountInfo from './components/account-info';
import workWxCommonService from '../../services/work-wx-common-service.js';
import customerService from '../services/customer-service.js';

export default {
  components: {
    AccountInfo,
  },
  data() {
    return {
      loading: false,
      queryParams: {
        isJump: false, // 是否为跳转到
      },
      search: {
        user_account_id: undefined,
      },
      userInfo: undefined,
    };
  },
  created() {
    this.isJump = this.$route.query.isJump;

    this.init();
  },
  methods: {
    init() {
      workWxCommonService.commonLogin();
    },
    async onSearch() {
      if (!this.search.user_account_id) {
        utils.showError({ msg: '请输入用户ID' });
        this.userInfo = undefined;
        return;
      }

      if (!/^[0-9]*$/.test(this.search.user_account_id)) {
        toast.show('请输入数字');
        return;
      }

      try {
        this.userInfo = undefined;
        const res = await this.getUserAccount({
          user_account_id: +this.search.user_account_id,
        });
        if (!res || !res.user_account_id) {
          utils.showError({ msg: '用户不存在' });
          return;
        }
        this.userInfo = res;
      } catch (e) {
        utils.showError(e);
      }
    },
    // 获取数据
    getUserAccount(params) {
      return new Promise((resolve, reject) => {
        this.loading = true;
        customerService
          .userInfoQuery(params)
          .then((res) => {
            resolve(res);
          })
          .catch((e) => {
            reject(e);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="less" scoped>
.bind-customer-account {
  background-color: #fff;
  font-size: 14px;
  line-height: 20px;
  height: 100vh;
  .header {
    height: 56px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    border-bottom: 1px solid #ededed;
    color: #222222;
    font-size: 14px;
    font-weight: 600;
    > img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }
  .content {
    .search-input {
      height: 56px;
      padding: 0 12px;
      display: flex;
      align-items: center;
      .input {
        height: 32px;
        padding-left: 12px;
        flex: 1;
        display: flex;
        align-items: center;
        background: rgba(237, 237, 237, 0.45);
        border-radius: 2px;
        > input {
          flex: 1;
          background: transparent;
          padding: 12px 8px; //12px 8px
          border: none;
          font-size: 14px;
          &::placeholder {
            font-size: 14px;
          }
        }
        img.pre-icon {
          width: 13px;
          height: 13px;
        }
      }
      .search-btn {
        height: 32px;
        display: flex;
        align-items: center;
        background: #00a2fc;
        border-radius: 2px;
        padding: 0 26px;
        color: #ffffff;
        margin-left: 12px;
        cursor: pointer;
      }
    }
  }
}
.loading {
  width: 100%;
  padding-top: 100px;
  background: #f5f6f7;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #918f8f;
}
</style>
